import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.less']
})
export class TestimonialComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-quote-size') quoteSize = '1.5em';
  @Input('skc-rows-height') rowsHeight = '0.875em';
  @Input('skc-avatar-height') avatarHeight = '3.250em';
  @Input('skc-avatar-width') avatarWidth = '3.250em';
  @Input('skc-rows') rows = 3;
  rowsTestimonial = [];
  quoteLeftImgSrc = 'assets/img/quote-left.svg';
  quoteRightImgSrc = 'assets/img/quote-right.svg';

  constructor() {
    super();
  }

  ngOnInit() {
    this.getRowsTestimonialArray(this.rows);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rows && !changes.rows.firstChange) {
      this.getRowsTestimonialArray(changes.rows.currentValue);
    }
    if (changes.avatarHeight && !changes.avatarHeight.firstChange && changes.avatarHeight.currentValue === '') {
      this.avatarHeight = '3.250em';
    }
    if (changes.avatarWidth && !changes.avatarWidth.firstChange && changes.avatarWidth.currentValue === '') {
      this.avatarWidth = '3.250em';
    }
    if (changes.rowsHeight && !changes.rowsHeight.firstChange && changes.rowsHeight.currentValue === '') {
      this.rowsHeight = '0.875em';
    }
    if (changes.quoteSize && !changes.quoteSize.firstChange && changes.quoteSize.currentValue === '') {
      this.quoteSize = '1.5em';
    }
  }

  getRowsTestimonialArray(changeRows: number) {
    this.rowsTestimonial = new Array(changeRows <= 1 ? 1 : changeRows - 1);
  }
}
